export const AMPLITUDE_DIALOG_NEWS = {
  CLOSE: 'Dialog News Close',
  SEE_MORE: 'Dialog News See More',
};
